import { GRADE } from './GradesConstants';

export const WEB_ENTRY_FIELD_NAMES = {
    STUDENT_NAME_FIELD: 'studName',
    DATE_FIELD: 'date',
    FORM_GRADE_FIELD: 'formGrade',
    FORM_NUMBER_FIELD: 'formNumber',
    CORRECT_FIELD: 'correct',
    INCORRECT_FIELD: 'incorrect',
    DYNAMIC_FIELD: 'dynamic',
};

export const WEB_ENTRY_TYPE_OF_CELLS = {
    BENCHMARK_CELLS: 'BENCHMARK_CELLS',
    PROGRESS_CELLS: 'PROGRESS_CELLS',
};

export const WEB_ENTRY_HEADER_TITLES = {
    DATE: 'Date',
    GRADE: 'Grade Level of Form',
    FORM_NUMBER: 'Form Number',
    CORRECT: 'Correct',
    INCORRECT: 'Incorrect',
};

export const CALENDAR_MENU = 'calendar-menu';
export const CLASS_NAME = {
    CORRECT_RESPONSES: 'correct-responses',
    INCORRECT_RESPONSES: 'incorrect-responses',
    PREVENT_VALIDATION: 'prevent-validation',
    LONG_CONTAINER: 'long-container',
};

export const DATE_PICKER = 'datePicker';

export const FORM = {
    FORM_GRADE: 'formGrade',
    FORM_NUMBER: 'formNumber',
};

export const WEB_ENTRY_DATE = {
    DATE: 'date',
    EMPTY_DATE: '- -/- -/- -',
    WEB_ENTRY_PANEL_DATE_FORMAT: 'MM/dd/yy',
};

export const RESPONSE = {
    CORRECT_RESPONSES: 'correctResponses',
    INCORRECT_RESPONSES: 'incorrectResponses',
};

export const VALIDATION = {
    VALIDATION_ERROR: 'validation-error',
    SAVING_SUCCESS: 'SAVING_SUCCESS',
    BASIC_COMPREHENSION_ONLINE_LOCK_DAYS_COUNT: 30,
    SECURE_BASIC_COMPREHENSION_ONLINE_LOCK_DAYS_COUNT: 2,
};

export const DATE_RANGE_ALERT_TYPE = 'DATE_RANGE_ALERT_TYPE';
export const DATE_RANGE_STRICTLY_ENFORCED_ALERT_TYPE = 'DATE_RANGE_STRICTLY_ENFORCED_ALERT_TYPE';
export const INVALIDATE_ALERT_TYPE = 'INVALIDATE_ALERT_TYPE';
export const TIME_TO_WAIT_FOR_INVALIDATE = 2000;

export const SUPPORTED_GRADES_WITH_BC = [
    GRADE.SECOND_GRADE,
    GRADE.THIRD_GRADE,
    GRADE.FOURTH_GRADE,
    GRADE.FIFTH_GRADE,
    GRADE.SIXTH_GRADE,
];

const WEB_ENTRY = 'web-entry';

export default WEB_ENTRY;
